import React from 'react';
import { observer } from 'mobx-react';
import { Element as ScrollTo } from 'react-scroll/modules';
import Error from '../../Components/UI/Messages/Error';
import { Warning } from '../../Components/UI/Messages/Warning';
import Keys from '../../../_Translations/generated/camper.en.t.json.keys';
import { Button } from 'reactstrap';
import { createFullQuery, loadCampersOrDetailsWithFilters, sessionSearch } from './externals';
import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/camper.en.t.json';
import CamperStore from './CamperStore';
import useWindow from '../../Hooks/useWindow';

const ErrorDisplay = observer(function ErrorDisplay({ store }: { store: CamperStore }) {
  const window = useWindow();
  const { t } = useTranslation('camper', fallback, Keys);

  return (
    <>
      <ScrollTo name={store.scrollElementGlobalError}>
        {store.error && !store.errorCamperNotFound && <Error message={t(store.error)} />}
        {!store.error && !store.errorCamperNotFound && store.warning && (
          <Warning message={t(store.warning)} />
        )}
        {store.errorCamperNotFound && (
          <>
            <Warning message={t(Keys.productNotAvailable)} />
            <Button
              className="mt-3 mb-4"
              color="primary"
              onClick={(): void => {
                const { productId, ...rest } = store.searchParams as Record<string, string>;
                createFullQuery(rest, store.filter, window);
                sessionSearch.set(window?.location?.href || '');
                loadCampersOrDetailsWithFilters(store, rest);
                store.resetErrorMessages();
              }}
            >
              {t(Keys.BACK_TO_LIST)}
            </Button>
          </>
        )}
      </ScrollTo>
    </>
  );
});

export default ErrorDisplay;
